/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sensitive_Info_WarningInputs */

const en_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not share this with anyone except the official Brave Support team.`)
};

const id_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan bagikan informasi ini kepada siapa pun kecuali tim Dukungan Brave resmi.`)
};

const ms_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan kongsikan dengan sesiapa kecuali pasukan Brave Support rasmi.`)
};

const ca_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No comparteixis aquesta informació amb ningú tret de l'equip oficial d'assistència de Brave.`)
};

const cs_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuto informaci nesdílejte s nikým jiným než s oficiálním týmem podpory Brave.`)
};

const da_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Del ikke dette med andre end det officielle Brave-kundeserviceteam.`)
};

const de_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib das nur an das offizielle Support-Team von Brave weiter.`)
};

const et_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ärge jagage seda kellegagi, välja arvatud Brave'i ametliku tugimeeskonnaga.`)
};

const es_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No compartas esto con nadie excepto con el equipo de Soporte oficial de Brave.`)
};

const fr_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne communiquez ces informations qu’à l’assistance Brave.`)
};

const hr_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne dijelite ove podatke ni sa kim osim sa službenim timom podrške Brave.`)
};

const it_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non condividere con nessuno tranne il team di supporto ufficiale di Brave.`)
};

const lv_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neizpaudiet šo informāciju nevienam, izņemot oficiālo Brave atbalsta komandu.`)
};

const lt_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nesidalinkite šia informacija su niekuo, išskyrus oficialią „Brave“ palaikymo komandą.`)
};

const hu_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ezt az információt kizárólag a Brave hivatalos ügyfélszolgálatával ossza meg.`)
};

const nl_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel dit met niemand behalve het officiële Brave Support-team.`)
};

const nb_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke del dette med noen andre enn Braves støtteteam.`)
};

const pl_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udostępniaj tego nikomu poza oficjalnym zespołem wsparcia Brave.`)
};

const pt_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não compartilhe isso com ninguém, exceto com a equipe oficial de Suporte do Brave.`)
};

const ro_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu împărtăși această informație nimănui, cu excepția echipei oficiale de asistență Brave.`)
};

const sk_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nezdieľajte túto informáciu s nikým iným okrem oficiálneho tímu podpory Brave.`)
};

const sl_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tega ne delite z nikomer, razen z uradno ekipo za podporo podjetja Brave.`)
};

const fi_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Älä jaa tätä kenenkään muun kuin virallisen Brave Support -tiimin kanssa.`)
};

const sv_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dela inte detta med någon annan än det officiella Brave Support-teamet.`)
};

const vi_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không chia sẻ thông tin này với bất kỳ ai ngoại trừ đội ngũ hỗ trợ chính thức của Brave.`)
};

const tr_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunu resmi Brave Destek ekibi dışında kimseyle paylaşmayın.`)
};

const el_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μην το μοιραστείτε με κανέναν άλλον εκτός από την επίσημη ομάδα υποστήριξης του Brave.`)
};

const bg_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не споделяй това с никого, освен с официалния екип за поддръжка на Brave.`)
};

const ru_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не делитесь этим ни с кем, кроме официальной команды поддержки Brave.`)
};

const sr_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не дајте ове информације никоме осим званичном Brave-овом тиму за подршку.`)
};

const uk_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не діліться цим ні з ким, окрім офіційної служби підтримки Brave.`)
};

const ka_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`არ გაუზიაროთ ეს ინფორმაცია არავის, გარდა Brave მხარდაჭერის ოფიციალური გუნდისა.`)
};

const hi_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसे ऑफिसियल ब्रेव सपोर्ट टीम के अलावा किसी और के साथ शेयर न करें।`)
};

const th_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อย่าแชร์สิ่งนี้กับใครยกเว้นทีมสนับสนุนอย่างเป็นทางการของ Brave เท่านั้น`)
};

const ko_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공식 Brave 지원팀 외 누구와도 이 정보를 공유하지 마세요.`)
};

const zh_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除了 Brave 的官方支持团队以外，请勿与任何人分享此信息。`)
};

const zh_tw_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除官方 Brave 支援團隊外，請勿將此資訊分享給任何人。`)
};

const ja_sensitive_info_warning = /** @type {(inputs: Sensitive_Info_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式のBraveサポートチーム以外の人には決して共有しないでください。`)
};

/**
* | output |
* | --- |
* | "Do not share this with anyone except the official Brave Support team." |
*
* @param {Sensitive_Info_WarningInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const sensitive_info_warning = /** @type {((inputs?: Sensitive_Info_WarningInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sensitive_Info_WarningInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sensitive_info_warning(inputs)
	if (locale === "ms") return ms_sensitive_info_warning(inputs)
	if (locale === "ca") return ca_sensitive_info_warning(inputs)
	if (locale === "cs") return cs_sensitive_info_warning(inputs)
	if (locale === "da") return da_sensitive_info_warning(inputs)
	if (locale === "de") return de_sensitive_info_warning(inputs)
	if (locale === "et") return et_sensitive_info_warning(inputs)
	if (locale === "es") return es_sensitive_info_warning(inputs)
	if (locale === "fr") return fr_sensitive_info_warning(inputs)
	if (locale === "hr") return hr_sensitive_info_warning(inputs)
	if (locale === "it") return it_sensitive_info_warning(inputs)
	if (locale === "lv") return lv_sensitive_info_warning(inputs)
	if (locale === "lt") return lt_sensitive_info_warning(inputs)
	if (locale === "hu") return hu_sensitive_info_warning(inputs)
	if (locale === "nl") return nl_sensitive_info_warning(inputs)
	if (locale === "nb") return nb_sensitive_info_warning(inputs)
	if (locale === "pl") return pl_sensitive_info_warning(inputs)
	if (locale === "pt") return pt_sensitive_info_warning(inputs)
	if (locale === "ro") return ro_sensitive_info_warning(inputs)
	if (locale === "sk") return sk_sensitive_info_warning(inputs)
	if (locale === "sl") return sl_sensitive_info_warning(inputs)
	if (locale === "fi") return fi_sensitive_info_warning(inputs)
	if (locale === "sv") return sv_sensitive_info_warning(inputs)
	if (locale === "vi") return vi_sensitive_info_warning(inputs)
	if (locale === "tr") return tr_sensitive_info_warning(inputs)
	if (locale === "el") return el_sensitive_info_warning(inputs)
	if (locale === "bg") return bg_sensitive_info_warning(inputs)
	if (locale === "ru") return ru_sensitive_info_warning(inputs)
	if (locale === "sr") return sr_sensitive_info_warning(inputs)
	if (locale === "uk") return uk_sensitive_info_warning(inputs)
	if (locale === "ka") return ka_sensitive_info_warning(inputs)
	if (locale === "hi") return hi_sensitive_info_warning(inputs)
	if (locale === "th") return th_sensitive_info_warning(inputs)
	if (locale === "ko") return ko_sensitive_info_warning(inputs)
	if (locale === "zh") return zh_sensitive_info_warning(inputs)
	if (locale === "zh-tw") return zh_tw_sensitive_info_warning(inputs)
	if (locale === "ja") return ja_sensitive_info_warning(inputs)
	return en_sensitive_info_warning(inputs)
});